/**
 * DISCLAIMER: This class has been migrated from js file
 * Therefore there are so many 'any' types.
 * Please feel free to refactor it.
 */
class LocalStorage {
  public static checkAvailability(): boolean {
    const testKey = '__test__';

    try {
      localStorage.setItem(testKey, '__test-value__');
      localStorage.removeItem(testKey);

      return true;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(
        'Local storage is not available! Some features will be disabled!',
      );

      return false;
    }
  }
  private readonly cache: Record<string, any> = {};

  private readonly isLocalStorageAvailable: boolean | null = null;

  public constructor() {
    this.isLocalStorageAvailable = LocalStorage.checkAvailability();
  }

  public get(key: string, def?: any) {
    if (this.cache[key]) {
      return this.cache[key];
    }

    let result = def;
    if (!this.isLocalStorageAvailable) {
      return result;
    }

    const data = localStorage.getItem(key);

    try {
      result = data ? JSON.parse(data) : def;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(
        `Error while parsing data from localStorage for key: ${key}.
        Error is: ${e.message}, stack is: ${e.stack}`,
      );
    }
    this.cache[key] = result;

    return result;
  }

  public remove(key: string) {
    if (!this.isLocalStorageAvailable) {
      return;
    }

    delete this.cache[key];

    localStorage.removeItem(key);
  }

  public set(key: string, item: any) {
    this.cache[key] = item;

    if (!this.isLocalStorageAvailable) {
      return;
    }

    localStorage.setItem(key, JSON.stringify(item));
  }
}

const storage = new LocalStorage();

export { LocalStorage };
export default storage;
